<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
<!--        <template slot="giveGarbage" slot-scope="data">
          <span>{{ $wtUtil.transWeight(data.row.giveGarbage) }}</span>
        </template>
        <template slot="getGarbage" slot-scope="data">
          <span>{{ $wtUtil.transWeight(data.row.getGarbage) }}</span>
        </template> -->
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'PROPERTYSTATISTICS_STAFF',
        formComponent: {
          list: { type: 'default', value: '/modules/orgIntegral/employeesIntegralList' }
        },
        formInputsData: [
          { name: '工作人员姓名', key: 'name', value: '', type: 'text' },
          { name: '时间', key: 'dataTimeRange', value: [], type: 'datetime' },
          { name: '机构层级',
            key: 'siteIdList',
            value: [],
            type: 'cascader',
            options: [],
            relateField: ['level'],
            filterable: true,
            props: { children: 'childList', label: 'name', value: 'id', expandTrigger: 'hover', emitPath: false, multiple: true }}],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/orgIntegral/employeesIntegralListExport',
          fileName: '物业经营统计-工作人员统计',
          permission: 'EXPORT' }],
        // 工作人员姓名，发放积分数，再生资源重量（kg），其他回收类型（个数）、出库重量（kg），核销积分
        formTableData: [
          { name: '工作人员姓名', key: 'name', type: 'text' },
          { name: '发放积分数', key: 'giveIntegral', type: 'text' },
          { name: '再生资源重量(kg) ', key: 'giveGarbage', type: 'text' },
          { name: '其他回收类型（个数）', key: 'otherCount', type: 'text' },
          { name: '出库重量（kg）', key: 'getGarbage', type: 'text' },
          // { name: '其他类型投递数量 ', key: 'otherCount', type: 'text' },
          { name: '核销积分', key: 'getIntegral', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, buttonHidden: true, index: true }
      }
    }
  },
  created() {
    this.orgTreeList()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {},
    // 站点
    orgTreeList() {
      this.$api.siteManage.org.orgTreeList().then(res => {
        this.$wtUtil.setSiteLevelKey(res.data)
        this.form.formInputsData[2].options = res.data
      })
    }
  }
}
</script>
